/**
 * V58: whether the position tracker shows RFQ positions (the trader's RFQ
 * bot's fills). Per trader, per browser: localStorage keyed by user id,
 * default on. Mixed positions (some dash, some RFQ fills) always show.
 */
import { create } from 'zustand';

const KEY_PREFIX = 'galactus:showRfqPositions:';

function read(userId: string | null): boolean {
  if (!userId) return true;
  try {
    return localStorage.getItem(KEY_PREFIX + userId) !== '0';
  } catch {
    return true;
  }
}

function write(userId: string | null, show: boolean): void {
  if (!userId) return;
  try {
    localStorage.setItem(KEY_PREFIX + userId, show ? '1' : '0');
  } catch {
    // Private window / blocked storage: the toggle still works this session.
  }
}

interface RfqPositionPrefs {
  userId: string | null;
  showRfq: boolean;
  /** Load the signed-in trader's preference (idempotent per user). */
  loadFor: (userId: string | null) => void;
  setShowRfq: (show: boolean) => void;
}

export const useRfqPositionPrefs = create<RfqPositionPrefs>((set, get) => ({
  userId: null,
  showRfq: true,
  loadFor: (userId) => {
    if (get().userId === userId) return;
    set({ userId, showRfq: read(userId) });
  },
  setShowRfq: (show) => {
    write(get().userId, show);
    set({ showRfq: show });
  },
}));
